import React from "react";
import { Container } from "reactstrap";
import { useTranslation } from "react-i18next";
import DataGrid, { DataTableWithPaginationProps } from "./Datagrid";

const MainPage = ({
  gridProps,
  title,
  metaTag,
}: {
  metaTag: string;
  title: string;
  gridProps: DataTableWithPaginationProps;
}) => {
  document.title = metaTag;
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <div className={"page-content"}>
        <Container fluid>
          <DataGrid {...gridProps} title={title} />
        </Container>
      </div>
    </React.Fragment>
  );
};
export default MainPage;
